// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"bda3fdf1","239":"55b4da83","453":"f21c5a21","553":"e8254ff9","644":"72f9a6ac","801":"c0750d70"}[chunkId] + ".chunk.js";
};